<template>
    <div class="calendar-free-container">
        <div class="calendar-free-text">
            {{ dragging ? $t('routines.create_new') : $t('common.free') }}
        </div>
    </div>
</template>

<script>
export default {
    name: "NoRoutinesInDate",
    props: {
        dragging: {
            type: Boolean,
            default: false,
        }
    }
}
</script>

<style scoped>

.calendar-free-container {
    position: relative;
    min-height: 80px;
}

.calendar-free-text {
    width: 90%;
    text-align: center;
    font-weight: 300;
    font-size: 12px;
    line-height: 12px;
    color: #03342C;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}

</style>